import { cn } from '../../lib/utils.js';
import logoUrl from '@interviewgator/brand/logo.png?url';

type Props = {
  className?: string;
  /** Use empty string when the wordmark next to the mark is sufficient for screen readers. */
  alt?: string;
};

/** Official InterviewGator logo (`img/logo.png` at repo root). */
export function GatorMark({ className, alt = 'InterviewGator' }: Props) {
  return (
    <img
      src={logoUrl}
      alt={alt}
      className={cn(
        'object-contain',
        /* mockups/project.pen — logoMark / logoDIcon: cornerRadius 12 (design tokens --ig-radius-md) */
        'overflow-hidden rounded-md',
        className,
      )}
      decoding="async"
    />
  );
}
